import { createSlice } from '@reduxjs/toolkit'

import { createCommunity, fetchCommunities } from './extraReducers'
import CommunityUtils from '../../components/utils/CommunityUtils'
import { createWordList } from '../wordLists/extraReducers'

const slice = createSlice({
    name: 'communities',
    initialState: {
        data: [] as any[],
        isCommunitiesLoading: false,
        isLoaded: false
    },
    reducers: {
        setCommunitiesRoutine: (state, action) => {
            state.data = action.payload
        },
        clearCommunities: (state) => {
            state.data = []
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCommunities.fulfilled, (state, action) => {
                state.data = CommunityUtils.parseCommunities(action.payload)
                state.isCommunitiesLoading = false
                state.isLoaded = true
            })
            .addCase(fetchCommunities.pending, (state) => {
                state.isCommunitiesLoading = true
                state.isLoaded = false
            })
            .addCase(fetchCommunities.rejected, (state) => {
                state.isCommunitiesLoading = false
                state.isLoaded = true
            })
            .addCase(createCommunity.fulfilled, (state, action) => {
                const community = CommunityUtils.parseCommunity(action.payload)
                state.isCommunitiesLoading = false
                state.data = [...state.data, community]
            })
            .addCase(createWordList.pending, (state) => {
                state.isCommunitiesLoading = true
            })
            .addCase(createWordList.rejected, (state) => {
                state.isCommunitiesLoading = false
            })
    }
})

export const { setCommunitiesRoutine } = slice.actions
export const communitiesLoadingStatusSelector = (state: any) => state.communities.isLoading
export const communitiesLoadedStatusSelector = (state: any) => state.communities.isLoaded
export const communitiesDataSelector = (state: any) => state.communities.data
export default slice.reducer
